import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import UserAvatar from './UserAvatar';
import UserSignOutLink from './UserSignOutLink';

function UserDropdown({ className, label }) {
  const [isOpen, setIsOpen] = useState(false);
  const userDropdownContainer = useRef(null);

  const handleClickOutside = (event) => {
    if (userDropdownContainer.current && !userDropdownContainer.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={userDropdownContainer} className={cx('user-dropdown', className, { open: isOpen })}>
      <div className="user-dropdown--toggle" onClick={() => setIsOpen(!isOpen)}>
        <UserAvatar />
        {label && <span className="user-dropdown--label">{label}</span>}
        <span className="user-dropdown--arrow" />
      </div>

      {isOpen &&
       <div className="user-dropdown--list" onClick={() => setIsOpen(false)}>
         <Link to="/profile" className="user-dropdown--list-item">
           Profile
         </Link>
         <UserSignOutLink className="user-dropdown--list-item" />
       </div>
      }
    </div>
  );
}

UserDropdown.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string
};

export default UserDropdown;
